import { CoherenceTheme } from "@coherence-design-system/styles";
import { loadTheme, ThemeProvider } from "@fluentui/react";
import React, { useState, useEffect } from "react";
import { HashRouter, Route, Routes, Navigate } from "react-router-dom";
import { Home } from "../pages/Home/Home";
import { SearchResult } from "../pages/SearchResult/Search";
import { Accounts } from "../pages/Accounts/Account";
import { Overview } from "../pages/Accounts/Overview";
import { AccountDetail } from "../pages/Accounts/AccountDetail";
import { QuotationDetail } from "../pages/Quotation/QuotationDetail/QuotationDetail";
import { QuotationInvoice } from "../pages/Quotation/QuotationInvoice/QuotationInvoice";
import { getAppStyles } from "./App.styles";
import { Providers, ProviderState } from "@microsoft/mgt-element";
import { axiosWrapper } from "../axiosWrapper";
import { CustomerAccount } from "../pages/CustomerAccount/CustomerAccount";
import { appInsights } from "../services/Logging/AppInsights";
import { CustomerNewAccount } from "../pages/CustomerAccount/AddNewCustomerAccount/CustomerNewAccount";
import { Quotation } from "../pages/Quotation/Quotation";
import { CustomerEditContact } from "../pages/CustomerAccount/EditCustomerAccount/CustomerEditContact";
import { CustomerAddAddress } from "../pages/CustomerAccount/EditCustomerAccount/CustomerAddAddress";
import { CountryProfile } from "../pages/CountryProfile/CountryProfile";
import CustomerProvider from "../pages/CustomerAccount/CustomerContext";
import { QuotationProvider } from "../pages/Quotation/QuotationContext";
import { CustomerDiscountSetup } from "../pages/CustomerAccount/CustomerDiscountSetup/DiscountSetup";
import { DPRProforma } from "../pages/Quotation/QuotationInvoice/DPRProforma";
import CountriesProfile from "../pages/CountriesProfile/CountryProfileList";
import CountryProfileProvider from "../pages/CountriesProfile/CountriesProfileContext";
import { AddQuotation } from "../pages/Quotation/AddQuotation/AddQuotation";
import { QuotationItems } from "../pages/Quotation/QuotationItems/QuotationItems";
import { RecentCustomers } from "../pages/Quotation/RecentCustomers/RecentCustomers";
import { CustomerEditAddress } from "../pages/CustomerAccount/EditCustomerAccount/CustomerEditAddressPivot";
import CountryProfileDetails from "../pages/CountriesProfile/CountryProfileDetails";
import CountryProfileEditDetails from "../pages/CountriesProfile/CountryProfileEditDetails";
import {
  LocalStorageContextDefaultValues,
  useLocalStorageContext,
  User,
} from "../Provider/LocalStorageProvider";
import { NetworkHealthProvider } from "../Provider/NetworkHealthProvider";
import BundleOption from "../pages/BundleOptions/BundleOption";
import { LoadingState } from "@coherence-design-system/loading-state";
import { HeaderComponent } from "../components/HeaderComponent/HeaderComponent";
import { useNavigationToggle } from "@coherence-design-system/navigation";
import { NavigationComponent } from "../components/NavigationComponent/NavigationComponent";
import { BundleItemSelectedKeyProvider } from "../pages/BundleOptions/BundleItelSelectedKeyContext";
import { QuoteProcessingMetrics } from "../pages/QuoteProcessingMetrics";
import { UserRoles } from "../common/enum/UserRoles";

const App: React.FunctionComponent = () => {
  loadTheme(CoherenceTheme);

  const { isNavCollapsed, toggleNavCollapsed } = useNavigationToggle();

  const [isCustomerAccount, setIsCustomerAccount] =
    React.useState<boolean>(false);
  const [isQuotation, setIsQuotation] = React.useState<boolean>(false);
  const onCustomerAccount = (isCustomerAccount: boolean): void => {
    setIsCustomerAccount(isCustomerAccount);
  };

  const appStyles = getAppStyles(isNavCollapsed, isCustomerAccount);
  const onQuotation = (isQuotation: boolean): void => {
    setIsQuotation(isQuotation);
  };
  const [isCountryProfile, setIsCountryProfile] =
    React.useState<boolean>(false);
  const onCountryProfile = (isCountryProfile: boolean): void => {
    setIsCountryProfile(isCountryProfile);
  };
  const [userData, setUserData] = useState<User>(
    LocalStorageContextDefaultValues
  );
  const { isUserSignedIn, isUserAuthorized, userRole, userRegions, setUser } =
    useLocalStorageContext();

  const getUserSignedIn = async () => {
    const provider = Providers.globalProvider;
    console.log("provider getUserSignedIn", provider);
    if (provider.state === ProviderState.SignedIn) {
      try {
        await getUserAuthorized();
        setUser((previousUser) => ({
          ...previousUser,
          isUserSignedIn: provider.state === ProviderState.SignedIn,
        }));

        console.log(
          "isUserSignedIn, isUserAuthorized, userRole, userRegions",
          isUserSignedIn,
          isUserAuthorized,
          userRole,
          userRegions
        );
      } catch (error) {
        console.error("Error during authorization check:", error);
        appInsights.trackException({
          error: new Error(error as string),
          properties: {
            name: "Error during authorization check in App.tsx",
          },
        });
      }
      console.log(
        "Inside If users getUserSignedIn",
        isUserSignedIn,
        isUserAuthorized,
        userRole,
        userRegions
      );
    } else {
      try {
        if (provider?.login) {
          await provider.login();
          setUser((previousUser) => ({
            ...previousUser,
            isUserSignedIn:
              provider && provider.state === ProviderState.SignedIn,
          }));
          console.log(
            "Inside try If users getUserSignedIn isUserSignedIn, isUserAuthorized, userRole, userRegions",
            isUserSignedIn,
            isUserAuthorized,
            userRole,
            userRegions
          );
        } else {
          console.error("Microsoft Graph Toolkit provider is not initialized");
          appInsights.trackTrace({
            message: "Microsoft Graph Toolkit provider is not initialized",
          });
        }
      } catch (error) {
        console.error("Error during login:", error);
        appInsights.trackException({
          error: new Error(error as string),
          properties: {
            name: "Error during login in App.tsx",
          },
        });
      }
    }
  };

  const getUserAuthorized = async () => {
    try {
      const response = await axiosWrapper.Get("Users/GetUserRoles");
      console.log("response getUserAuthorized", response);
      if (
        response?.data?.data?.role === null ||
        response?.data?.data?.role === undefined
      ) {
        setUser((previousUser) => ({
          ...previousUser,
          // isUserSignedIn: userData.isUserSignedIn,
          isUserAuthorized: false,
          userRole: -1,
          userRegions: [],
          genericRole: -1,
        }));
        console.log(
          "user getUserAuthorized isUserSignedIn, isUserAuthorized, userRole, userRegions,",
          isUserSignedIn,
          isUserAuthorized,
          userRole,
          userRegions
        );
      } else {
        const { role, regions } = response?.data?.data;
        setUser((previousUser) => ({
          ...previousUser,
          isUserSignedIn: isUserSignedIn,
          isUserAuthorized: true,
          userRole: role,
          userRegions: regions,
          genericRole: role < 4 || role === 6 ? role : -1,
        }));

        console.log(
          "user getUserAuthorized isUserSignedIn, isUserAuthorized, userRole, userRegions,",
          isUserSignedIn,
          isUserAuthorized,
          userRole,
          userRegions
        );

        console.log("role regions getUserAuthorized", role, regions);
      }
    } catch (error) {
      localStorage.clear();
      appInsights.trackException({
        error: new Error(error as string),
        properties: { name: "Error in GetUserRoles API in App.tsx" },
      });
      console.log("Error in GetUserRoles API:", error);
    }
  };

  useEffect(() => {
    const handleLoginChange = async () => {
      if (!isUserSignedIn) {
        const user = localStorage.getItem("user");
        console.log("Inside App.tsx use Effect user", user);
        if (user) {
          const userObj = JSON.parse(user);
          console.log("Inside App.tsx use Effect userObj", userObj);
          if (!userObj?.isUserSignedIn && !userObj?.isUserAuthorized) {
            await getUserSignedIn();
            console.log("Inside App.tsx use Effect if userObj", userObj);
          } else if (userObj?.isUserSignedIn && !userObj?.isUserAuthorized) {
            await getUserAuthorized();
            console.log("Inside App.tsx use Effect else if userObj", userObj);
          } else if (userObj?.isUserSignedIn && userObj?.isUserAuthorized) {
            setUser({
              ...userObj,
            });
            console.log("Inside App.tsx use Effect else userObj", userObj);
          }
        } else {
          await getUserSignedIn();
          console.log(
            "User in use effect",
            userData,
            isUserSignedIn,
            isUserAuthorized,
            userRole,
            userRegions
          );
        }
      }
    };

    Providers.onProviderUpdated(handleLoginChange);

    if (!isUserSignedIn) {
      handleLoginChange();
    }
  }, []);

  useEffect(() => {
    setUserData({
      ...userData,
      isUserSignedIn,
      isUserAuthorized,
      userRole,
      userRegions,
    });
    console.log(
      "USER DATA:::",
      userData,
      isUserSignedIn,
      isUserAuthorized,
      userRole,
      userRegions
    );
  }, [isUserSignedIn, isUserAuthorized]);

  console.log(
    "User in global component scope",
    userData,
    isUserSignedIn,
    isUserAuthorized,
    userRole,
    userRegions
  );

  return (
    <div className="App">
      <NetworkHealthProvider>
      <header>
        {userData.isUserSignedIn && userData.isUserAuthorized ? (
          <ThemeProvider>
              <CustomerProvider>
                <QuotationProvider>
                  <CountryProfileProvider>
                  
                    <HashRouter>
                      <HeaderComponent
                        isNavCollapsed={isNavCollapsed}
                        toggleNavCollapsed={toggleNavCollapsed}
                      />
                      <NavigationComponent
                      isNavCollapsed={isNavCollapsed}
                      toggleNavCollapsed={toggleNavCollapsed}
                    />
                    <main id="main" tabIndex={-1} className={appStyles.root}>
                      <Routes>
                        <Route path="/" element={<Home />} />
                        <Route
                          path="/QuoteProcessingMetrics"
                          element={
                            userRole === UserRoles.Manager || userRole === UserRoles.Admin ? (
                              <QuoteProcessingMetrics />
                            ) : (
                              <Navigate to="/" replace />
                            )
                          }
                        />
                        <Route
                          path="/AccessRequest"
                          element={<CountryProfile />}
                        />
                        <Route path="/Search" element={<SearchResult />} />
                        <Route path="/Account" element={<Accounts />} />
                        <Route path="/Overview" element={<Overview />} />
                        <Route
                          path="/AccountDetail"
                          element={<AccountDetail />}
                        />
                        <Route
                          path="/Customer"
                          element={
                            <CustomerAccount
                              onCustomerAccount={onCustomerAccount}
                            />
                          }
                        />
                        <Route
                          path="/CustomerNewAccount"
                          element={
                            <CustomerNewAccount
                              onCustomerAccount={onCustomerAccount}
                            />
                          }
                        />
                        <Route
                          path="/CustomerEditContact"
                          element={
                            <CustomerEditContact
                              onCustomerAccount={onCustomerAccount}
                            />
                          }
                        />
                        <Route
                          path="/CustomerAddAddress"
                          element={
                            <CustomerAddAddress
                              addressType=""
                              onCustomerAccount={onCustomerAccount}
                            />
                          }
                        />
                        <Route
                          path="/CustomerEditAddress"
                          element={
                            <CustomerEditAddress
                              onCustomerAccount={onCustomerAccount}
                            />
                          }
                        />
                        <Route
                          path="/CustomerDiscountSetup"
                          element={
                            <CustomerDiscountSetup
                              onCustomerAccount={onCustomerAccount}
                            />
                          }
                        />
                        {/* <QuotationProvider> */}
                        <Route
                          path="/AllQuotations"
                          element={<Quotation onQuotation={onQuotation} />}
                        />
                        <Route
                          path="/RecentCustomers"
                          element={
                            <RecentCustomers onQuotation={onQuotation} />
                          }
                        />
                        <Route
                          path="/AddQuotation"
                          element={<AddQuotation onQuotation={onQuotation} />}
                        />
                        <Route
                          path="/EditQuotation"
                          element={<AddQuotation onQuotation={onQuotation} />}
                        />
                        <Route
                          path="/QuotationLineItems"
                          element={<QuotationItems onQuotation={onQuotation} />}
                        />
                      
                        <Route
                          path="/BundleAndItemSelection"
                          element={
                            <BundleItemSelectedKeyProvider>
                              <BundleOption />
                            </BundleItemSelectedKeyProvider>
                          }
                        />
                        <Route
                          path="/QuotationDetail"
                          element={<QuotationDetail />}
                        />
                        <Route
                          path="/QuotationInvoice"
                          element={<QuotationInvoice />}
                        />
                        <Route path="/DPRProforma" element={<DPRProforma />} />
                        {/* <CountryProfileProvider> */}
                        <Route
                          path="/CountryProfile"
                          element={
                            <CountriesProfile
                              onCountryProfile={onCountryProfile}
                            />
                          }
                        />

                        <Route
                          path="/CountryProfile/CountryDetails"
                          element={
                            <CountryProfileDetails
                              onCountryProfile={onCountryProfile}
                            />
                          }
                        />
                        <Route
                          path="/CountryProfile/EditDetails"
                          element={
                            <CountryProfileEditDetails
                              onCountryProfile={onCountryProfile}
                            />
                          }
                        />
                      </Routes>
                    </main>
                  </HashRouter>
                  
                  </CountryProfileProvider>
                </QuotationProvider>
              </CustomerProvider>
          </ThemeProvider>
        ) : userData.isUserSignedIn && !userData.isUserAuthorized ? (
          <ThemeProvider>
            <HashRouter>
              <main id="main" tabIndex={-1}>
                <Routes>
                  <Route
                    path="/"
                    element={
                      <div
                        style={{
                          height: "500px",
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                          marginTop: 50,
                        }}
                      >
                        <CountryProfile />
                      </div>
                    }
                  />
                </Routes>
              </main>
            </HashRouter>
          </ThemeProvider>
        ) : (
          <div
            style={{
              height: "500px",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <LoadingState primaryText="Loading..." styles={{}} />
          </div>
        )}
      </header>
      </NetworkHealthProvider>
    </div>
  );
};

export default App;
